/* Boxy storefront ecommerce events. Purchase belongs to checkout tracking. */
(function () {
  'use strict';
  if (window.boxyCommerceInitialized) return;
  var contextElement = document.getElementById('boxy-commerce-context');
  if (!contextElement) return;
  var context;
  try { context = JSON.parse(contextElement.textContent); } catch (_) { return; }
  window.boxyCommerceInitialized = true;
  var items = context.items || [];
  var currency = context.currency;
  var pageSent = false;
  var checkoutSent = false;
  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && privacy.analyticsProcessingAllowed() && typeof window.gtag === 'function');
  }
  function validItem(item) {
    return item && item.item_id && Number.isFinite(Number(item.price)) && Number(item.price) >= 0 && Number(item.quantity) > 0;
  }
  function emit(name, selected) {
    if (!allowed()) return false;
    selected = selected.filter(validItem).slice(0, 200);
    if (!selected.length) return false;
    window.gtag('event', name, {
      send_to: context.measurementId,
      currency: currency,
      value: selected.reduce(function (sum, item) { return sum + Number(item.price) * Number(item.quantity); }, 0),
      items: selected,
      transport_type: 'beacon'
    });
    return true;
  }
  function pageView() {
    if (pageSent) return;
    if (context.pageType === 'product' && context.product) pageSent = emit('view_item', [context.product]);
    else if (context.pageType === 'cart') pageSent = emit('view_cart', items);
  }
  function publicItem(line, quantity) {
    return {
      item_id: String(line.variant_id || line.id),
      item_name: line.product_title || line.title,
      item_variant: line.variant_title || 'Default Title',
      price: Number(line.final_price == null ? line.price : line.final_price) / 100,
      quantity: Number(quantity)
    };
  }
  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (!event.promise || typeof event.promise.then !== 'function') return;
    event.promise.then(function (result) {
      var detail = result && result.detail;
      if (!detail || detail.didError || !Array.isArray(detail.items)) return;
      items = detail.items.map(function (line) { return publicItem(line, line.quantity); });
      currency = result.cart && result.cart.cost && result.cart.cost.totalAmount.currencyCode || currency;
      if (event.action !== 'add' || !Array.isArray(event.lines)) return;
      var added = event.lines.map(function (request) {
        var id = String(request.merchandiseId || '').split('/').pop();
        var line = detail.items.find(function (item) { return String(item.variant_id || item.id) === id; });
        return line && publicItem(line, request.quantity);
      }).filter(Boolean);
      emit('add_to_cart', added);
    }).catch(function () { /* Failed cart requests are not successful additions. */ });
  });
  function beginCheckout() {
    if (!checkoutSent) checkoutSent = emit('begin_checkout', items);
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target instanceof Element && event.target.closest('a[href],button[name="checkout"],input[name="checkout"]');
    if (!trigger || trigger.disabled || event.defaultPrevented) return;
    if (trigger.name === 'checkout') {
      var form = trigger.form;
      if (!form || form.checkValidity()) beginCheckout();
    } else if (trigger.href) {
      var url = new URL(trigger.href, location.origin);
      if (url.origin === location.origin && /\/checkout\/?$/.test(url.pathname)) beginCheckout();
    }
  });
  document.addEventListener('submit', function (event) {
    if (event.defaultPrevented) return;
    var button = event.submitter;
    if (button && button.name === 'checkout') beginCheckout();
  });
  document.addEventListener('visitorConsentCollected', pageView);
  var attempts = 0;
  function initialize() {
    pageView();
    if (!pageSent && ++attempts < 30) setTimeout(initialize, 100);
  }
  initialize();
})();
